import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for routing

const CONTACT_API = `${process.env.REACT_APP_BASE_URL}/contact.php`;

const Modal = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    comments: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');

  // Initialize navigate for redirecting
  const navigate = useNavigate();

  // Function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Function to submit the form data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus('');

    try {
      const response = await fetch(CONTACT_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormStatus('Thank you for your demo request!');
      } else {
        setFormStatus('Something went wrong, please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      setFormStatus('Failed to send. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Close modal and redirect to home page using React Router
  const closeAndRedirect = () => {
    closeModal(); // Close modal
    navigate('/'); // Navigate to the home page (index.html)
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg w-full max-w-md relative">
        <h2 className="text-xl font-semibold text-center mb-4">Request a Demo/Contact us</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium">Mobile</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium">Comments</label>
            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {formStatus && (
            <div className="text-center mb-4 text-green-600">{formStatus}</div>
          )}

          <div className="text-center">
            <button
              type="submit"
              className="bg-blue-500 text-white px-6 py-2 rounded-full font-semibold"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
        <button
          onClick={closeAndRedirect} // Use the closeAndRedirect function
          className="absolute top-2 right-2 text-gray-500 text-xl"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default Modal;
